'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './upload-archive.routes';

export class UploadArchiveComponent {

  constructor(StorageService, $timeout, $uibModal, Config, dialogs, DTOptionsBuilder, prompt) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.roles = Config.getPlatformConfig().getPermissionRoles();

    this.dialogs = dialogs;
    this.prompt = prompt;

    this.$uibModal = $uibModal;
    this.dataReady = false;

    this.countTags = {};
    this.tags = [];

    this.asTable = true;

    this.currentPage = 1;
    this.itemsPerPage = Config.getPaginationWithDefault("uploadArchive", 18);

    this.data = [];
    this.month = ["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

    this.StorageService = StorageService;
    this.$timeout = $timeout;
    this.baseUrl = Config.getPlatformConfig().getBaseUrl();

    this.currentYear = moment().format("YYYY");
    this.currentMonth = moment().format("M");

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('responsive', true)
      .withBootstrap();

    this.refreshData();
  }

  resetFilter() {
    this.filter = "";
    this.applyFilter();
  }

  resetFilterTag() {
    this.currentFilterTag = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataByMonth = {
      1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: [], 10: [], 11: [], 12: [], older: []
    };

    let lcFilter = (this.filter) ? this.filter.toLowerCase() : "";

    this.rawData  // filename can be undefined when stored in database
      .filter(item => !this.currentFilterTag || (item.tags.findIndex(tag => tag.text === this.currentFilterTag) !== -1))
      .filter(item => !this.filter || (item.filename && item.filename.toLowerCase().includes(lcFilter)) || item._id == this.filter)
      .forEach(item => {
      var month = moment(item.creationDate).format("M");
      var year = moment(item.creationDate).format("YYYY");

      if (year !== this.currentYear) {
        this.dataByMonth["older"].push(item);
      } else {
        this.dataByMonth[month].push(item);
      }
    });

    var that = this;
    this.$timeout(function(){
      that.dataReady = true;

      let idx = (that.currentMonth == 'older') ? 13 : that.currentMonth;

      jQuery("ul.nav.nav-tabs li:nth-child("+idx+") a").click();
    }, 200);
  }

  editFilename(storageItem) {
    this.prompt({
      title: 'Change Filename',
      //message: 'Enter new filename',
      input: true,
      label: 'New Filename:',
      value: storageItem.filename
    }).then(newName => {

      this.StorageService.update({id: storageItem._id}, {filename: newName}, _=> {
        this.refreshData();
      }, err => console.log(err));
      
    });
  }

  refreshData() {
    this.tags = [];
    this.countTags = {};
    this.StorageService.query(
      data => {
        this.rawData = data;

        this.rawData.forEach(asset => {
          asset.tags.forEach(tag => {
            if (!this.countTags[tag.text])
              this.countTags[tag.text] = 0;

            this.countTags[tag.text]++;
          })
        });

        Object.keys(this.countTags).forEach(tag => {
          this.tags.push({
            text: tag + " (" + this.countTags[tag] + ")",
            tag: tag
          })
        });

        this.applyFilter();
      },
      err => {
        console.log('Could not retrieve data.');
      });
  }

  setAsTable(val) {
    this.asTable = val;
  }

  isActive(month) {
    return month == this.currentMonth;
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  openImageEditor(asset) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'imageEditor',
      resolve: {
        config: function() {
          return {
            storageId: asset._id
          }
        }
      }
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }

  openAssetPermissionModal(asset) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetPermission',
      resolve: {
        config: function() {
          return {
            asset: angular.copy(asset)
          }
        }
      }
    });

    modalInstance.result.then(
      function () {
        that.refreshData();
      },
      function () { /* cancel */ }
    );

  }

  openAssetTagsModal(asset) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetTags',
      resolve: {
        config: function() {
          return {
            asset: angular.copy(asset)
          }
        }
      }
    });

    modalInstance.result.then(
      function () {
        that.refreshData();
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function () {
        that.refreshData();
      },
      function () { /* cancel */ }
    );

  }

  setFilter(month) {
    if (!this.dataReady)
      return;

    this.currentPage = 1;
    this.data = this.dataByMonth[month];
    this.currentMonth = month;
  }

  getCount(month) {
    if (!this.dataReady)
      return 0;
    
    return this.dataByMonth[month].length;
  }

  getUserShort(user) {
    return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
  }

  copyToClipboard(asset) {
    let publicPath = asset.isPublic ? "public/" : "";
    let path = this.baseUrl + "/api/storage/" + publicPath + asset._id;
    window.prompt("Path to Resource:", path);
  }

  delete(item) {
    var that = this;

    var docText = "<br/><br/><b>" + item.filename + "</b>";

    var dlg = this.dialogs.confirm("Delete File?", "Do you really want to delete this file?" + docText);
    dlg.result.then(() => {
      // OK delete it
      that.StorageService.delete({id: item._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== item._id;
          });
        },
        err => {
          alert("Could not delete storage item");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduuApp.uploadArchive', [uiRouter])
  .config(routes)
  .component('uploadArchive', {
    template: require('./upload-archive.html'),
    controller: UploadArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/upload/archive/upload-archive.component.js